
<template>
  <div class="x_box">
        <ol class="breadcrumb x_breadcrumb">
            <li class="breadcrumb-item">
                <router-link to="/Vendor">{{ $t('vendor_list') }}</router-link>
            </li>
            <li class="breadcrumb-item active" aria-current="page">{{ title }}</li>
        </ol>
    <div class="x_header">
      <button type="button" class="btn btn-outline-primary btn-sm no-bor" @click="$router.go(-1)"><i class="fa fa-arrow-circle-o-left"></i> {{ $t('back') }}</button>
      <button type="button" class="btn btn-outline-primary btn-sm no-bor" @click="clickSaveHandler">
        <i class="fa fa-floppy-o"></i>
        {{ $t('save') }}
      </button>
    </div>
    <div class="x_body">
      <div class="card x_card">
        <div class="card-body">
          <div v-if="$v.$error" class="alert alert-danger x-error">
            <div class="error" v-if="!$v.model.Name.required">- សូមធ្វើការបញ្ជូលឈ្មោះអ្នកផ្គត់ផ្គង់</div>
            <div class="error" v-if="!$v.model.Phone.required">- សូមធ្វើការបញ្ជូលលេខទូរស័ព្ទ</div>
          </div>
          <div class="row">
            <div class="col-sm-6">
              <div class="flex-container">
                <div>
                  <input type="file" ref="file" @change="fileChangeHandler" accept="image/*" style="display:none;"/>
                  <img :src="img" alt="" class="img-thumbnail" style="width: 135px; height: 125px;" @click="$refs.file.click()">
                </div>
                <div class="flex-right">
                  <div class="form-group" :class="{ 'form-group-error': $v.model.Name.$error }">
                    <label class="label-control blue">{{ $t('khmer_name')}}</label>
                    <div><input class="form-control form-control-sm" type="text" v-model="$v.model.Name.$model" /></div>
                  </div>
                  <div class="form-group">
                    <label class="label-control blue">VAT TIN</label>
                    <div>
                      <div class="row">
                        <div class="col-sm-3 col-lg-2">
                          <input type="text" class="form-control form-control-sm" v-model="model.TinHead"/>
                        </div>
                        <div class="col-sm-9 col-lg-10">
                          <b-form-input class="form-control-sm" v-model="model.VatTin"/>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="row">
            <div class="col-sm-6">
              <div class="form-group">
                <label class="label-control blue">{{ $t('latin_name')}}</label>
                <div><input class="form-control form-control-sm" type="text" v-model="model.NameEng" /></div>
              </div>
            </div>
          </div>
          <div class="row">
            <div class="col-sm-3">
              <div class="form-group" :class="{ 'form-group-error': $v.model.Phone.$error }">
                <label class="label-control blue">{{ $t('phone')}}</label>
                <div>
                  <input class="form-control form-control-sm" type="text" v-model="$v.model.Phone.$model" />
                </div>
              </div>
            </div>
            <div class="col-sm-3">
              <div class="form-group">
                <label class="label-control blue">{{ $t('email') }}</label>
                <div>
                  <input class="form-control  form-control-sm" type="email" v-model="model.Email" />
                </div>
              </div>
            </div>
          </div>
          <div class="row">
            <div class="col-sm-3">
              <div class="form-group">
                <label class="label-control blue">{{ $t('website') }}</label>
                <div>
                  <input class="form-control form-control-sm" type="text" v-model="model.Website" />
                </div>
              </div>
            </div>
            <div class="col-sm-3">
              <div class="form-group">
                <label class="label-control blue">{{ $t('contact_name') }}</label>
                <div>
                  <input class="form-control form-control-sm" type="text" v-model="model.ContactName" />
                </div>
              </div>
            </div>
          </div>
          <div class="row">
            <div class="col-sm-3">
              <div class="form-group">
                <label class="label-control blue">{{ $t('contact_number') }}</label>
                <div>
                  <input class="form-control form-control-sm" type="text" v-model="model.ContactPhone" />
                </div>
              </div>
            </div>
            <div class="col-sm-3">
              <div class="form-group">
                <label class="label-control blue">{{ $t('address') }}</label>
                <div>
                  <input class="form-control form-control-sm" type="text" v-model="model.Address" />
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
  import { required } from 'vuelidate/lib/validators'
export default {
  data: function() {
    return {
      model: {
        Name: "",
        Phone: "",
        VatTin: "",
        TinHead: ""
      },
      actionLink: 'vendor/save',
      title: this.$t('new'),
      img: '/img/no-image.svg',
      formHead: {
          headers: {
              'Content-Type': 'multipart/form-data'
          }
      }
    }
  },
  validations: {
    model :{
      Name: {required},
      Phone: {required},
    }
  },
  created: function(){
    let id = this.$route.params.id;
    if(id != undefined && id != null && id != ''){
      this.actionLink = 'vendor/update';
      this.$api().post('vendor/find', { Id: id }).then(res =>{
        if(res.data != null){
          this.model = res.data.Data;
          this.title = '['+this.model.Name+']';
          if(this.model.Logo != null){
            this.img = this.$base() + 'image/logo/' + this.model.Logo;
          }
        }
      });
    }
  },
  methods: {
    clickSaveHandler: function() {
      this.$v.$touch();
      if (!this.$v.$invalid) {
        let loading = this.$loading.show();
        let formData = new FormData();
        formData.append('File', this.$refs.file.files[0]);
        for (let p in this.model) {
          let val = this.model[p];
          if(val != null)
            formData.append(p, val);
        }
        this.$api().post(this.actionLink, formData, this.formHead).then(res => {
          if (this.$isValid(res)) {
            this.$router.push("/vendor");
          }
        }).finally(function () {
          loading.hide();
        });
      }
    },
    fileChangeHandler: function(e){
      const file = e.target.files[0];
      this.img = URL.createObjectURL(file);
    }
  }
};
</script>
